import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_play",
  "use": "icon-ic_play-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_play\">\n<g id=\"icon-ic_play_ic_play\">\n<path id=\"icon-ic_play_Vector\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.2 12L7.1 5.1592L7.1 18.8408L16.2 12ZM18.58 12.8419C19.14 12.421 19.14 11.579 18.58 11.1581L6.68 2.2124C5.9878 1.69205 5 2.18709 5 3.05434L5 20.9457C5 21.8129 5.9878 22.308 6.68 21.7876L18.58 12.8419Z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol